import { FilterBuilder } from '@/shared/filters/filter-builder';
import { UserRoleFilterInput } from '@/shared/types/types.generated';

export class UserRoleFilterBuilder extends FilterBuilder<
  UserRoleFilterInput,
  UserRoleFilterBuilder
> {
  public allowedFilters: Array<keyof UserRoleFilterInput> = [
    'name',
    'creationTimestamp',
    'updateTimestamp',
    'groupId',
  ];

  constructor() {
    super();

    this.fieldMappings = {
      name: 'nameLower' as keyof UserRoleFilterInput,
    };

    this.valueTransformers = {
      name: (value: string) => value.toLowerCase(),
    };
  }
}
